import { Validators } from '@angular/forms';
import { MultipleContractTypeSelectorComponent } from '@ordersnproducts/modules/one-click-order/components/contract-invoice-select/contract-invoice-select.component';
import { PurchaseOrderComponent } from '@ordersnproducts/modules/one-click-order/components/purchase-order/purchase-order.component';
import { OneClickContractEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-contract.effects';
import { OneClickHaulersEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-hauler.effect';
import { OneClickHolidaysEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-holidays.effects';
import { OneClickJobsiteSalesAreaFromOrderEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-jobsite-sales-area.effects-order';
import { OneClickOwnFreightPlantsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-ownFreight-plants.effects';
import { OneClickSalesAreaErrorEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-sales-area-error.effects';
import { OneCLickAlternativeUnitsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-units.effects';
import {
  OneClickNoResultHasInvoiceProvider,
  OneClickNoResultNoInvoiceProvider,
} from '@ordersnproducts/modules/one-click-order/providers/order/one-click-contract-type-result.provider';
import { OneClickContractProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-contract.provider';
import { OneClickDeliveryDateProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-date.provider';
import { OneClickDeliveryMethodProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-method.provider';
import { OneClickHaulerProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-hauler.provider';
import { OneClickMultipleOption } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-is-multiple-option.provider';
import { OneClickOwnFreightPlantProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-ownFreight-plant.provider';
import { OneClickPreviewHaulersLoadingProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-preview-haulers-loading.provider';
import { OneClickPreviewOwnFreightPlantsLoadingProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-preview-ownFreight-plants-loading.provider';
import { OneClickPreviewVehiclesLoadingProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-preview-vehicles-loading.provider';
import { OneClickPurchaseOrderProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-purchase-order.provider';
import { OneClickStandardLotProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-standard-lot.provider';
import { OneClicVehicleProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-vehicle.provider';
import { OneClickSetHauler } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-hauler.command.service';
import { OneClickSetPlant } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-plant.command.service';
import { OneClickSetPurchaseOrder } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-purchase-order.command';
import { OneClickSetQuantityOrder } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-quantity.command.service';
import { OneClickSetRequestedDateTime } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-requested-date-time.command.service';
import { OneClickUpdateSalesArea } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-sales-area.command';
import { OneClickSetUnitOrder } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-unit-command.service';
import { OneClickSetVehicle } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-vehicle.command.service';
import { OneClickHaulersLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-haulers.loader.services';
import { OneClickOwnFreightPlantsLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-ownFreight-plants.loader.service';
import { OneClickUnitsLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-units.loader.service';
import { OneClickVehiclesLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-vehicles.loader.service';
import { OneClickBuilderField } from '@ordersnproducts/modules/one-click-order/util/constants/builder-fields';
import { OneClickPurchaseOrderValidator } from '@ordersnproducts/modules/one-click-order/validators/one-click-purchase-order.validator';
import { MAX_LENGTH_PO } from '@ordersnproducts/modules/order-builder/modules/location/constants/purchase-order.constants';
import { FormInputDateDisabledDatesComponent } from '@ordersnproducts/modules/order-builder/modules/specification/components/form/form-input-date-disabled-dates/form-input-date-disabled-dates.component';
import { defaultDateTranslationNames } from '@ordersnproducts/modules/order-builder/modules/specification/configs/defaultDateTranslationNames';
import { ContractBalanceEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/contract-balance.effects';
import { DecimalProvider } from '@ordersnproducts/modules/order-builder/modules/specification/providers/decimal.provider';
import { FieldDateInputConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/models/field-date-input.config';
import { WeekDay } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/models/week-day';
import { FormInputNumberComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import { FormSelectComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/field-select-config.interface';
import { FormSeparatorComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-separator/form-separator.component';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { OneClickLocationProvider } from '../../../../providers/order/one-click-location.provider';
import { OneClickLocationDisplayer } from '../../../../providers/order/one-click-multiple-jobsite-displayer.provider';
import {
  OneClickContractPaymentProvider,
  OneClickHasResultProvider,
  OneClickNoResultProvider,
} from '../../../../providers/order/one-click-payment.provider';
import { OneClickProductProvider } from '../../../../providers/order/one-click-product.provider';
import { OneClickPreviewField } from '../../../../util/constants/preview-fields';

export const preview: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Jobsite,
    label: 'views.one_click.jobsite',
    hidden: OneClickLocationDisplayer.HideJobsite,
    text: OneClickLocationProvider.TextPreview,
    dataTIdLabel: 'cmx-createoneclickorder-lbltagjobsite',
    dataTIdValue: 'cmx-createoneclickorder-lblvaljobsite',
    containerClassNames: ['col-md-4 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PointOfDelivery,
    label: 'views.one_click.pod',
    hidden: OneClickLocationDisplayer.HidePointOfDelivery,
    text: OneClickLocationProvider.TextPreview,
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpointofdelivery',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpointofdelivery',
    containerClassNames: ['col-md-4 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.DeliveryMethod,
    text: OneClickDeliveryMethodProvider.TextPreview,
    label: 'views.one_click.delivery_method',
    containerClassNames: ['col-md-4 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagdeliverymethod',
    dataTIdValue: 'cmx-createoneclickorder-lblvaldeliverymethod',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Product,
    text: OneClickProductProvider,
    label: 'views.one_click.product',
    containerClassNames: ['col-md-4 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagproduct',
    dataTIdValue: 'cmx-createoneclickorder-lblvalproduct',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Payment,
    text: OneClickContractPaymentProvider,
    label: 'views.one_click.payment_method',
    containerClassNames: ['col-md-4 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpayment',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpayment',
  } as FieldLabelConfig,
  {
    type: FormSeparatorComponent,
    name: '',
    containerClassNames: ['col-md-12'],
    hidden: OneClickHasResultProvider,
    visible: OneClickMultipleOption.IsSingleOption,
  } as FieldConfig,
  {
    type: PurchaseOrderComponent,
    name: OneClickPreviewField.PurchaseOrder,
    label: 'views.one_click.purchase_order',
    dynamicEffects: [OneClickJobsiteSalesAreaFromOrderEffects],
    onChange: [OneClickSetPurchaseOrder],
    hidden: OneClickHasResultProvider,
    placeholder: 'views.one_click.enter_purchase_order',
    containerClassNames: ['col-md-6 retail-control text-capitalize mb-3'],
    validation: [Validators.maxLength(MAX_LENGTH_PO)],
    asyncValidators: [OneClickPurchaseOrderValidator.validator],
  } as FieldConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PurchaseOrder,
    hidden: OneClickNoResultProvider,
    text: OneClickPurchaseOrderProvider,
    label: 'views.one_click.purchase_order',
    containerClassNames: ['col-md-4'],
  } as FieldLabelConfig,
  {
    type: FormSelectComponent,
    name: OneClickPreviewField.Hauler,
    label: 'views.one_click.hauler',
    placeholder: 'views.one_click.select.hauler',
    optionsLoader: OneClickHaulersLoaderService,
    loading: OneClickPreviewHaulersLoadingProvider,
    hidden: OneClickHasResultProvider,
    onChange: [OneClickSetHauler],
    dynamicEffects: [OneClickHaulersEffects],
    containerClassNames: ['col-md-6 text-capitalize retail-control mb-3'],
    validation: [Validators.required],
  } as FieldSelectConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Hauler,
    text: OneClickHaulerProvider,
    hidden: OneClickNoResultProvider,
    label: 'views.one_click.hauler',
    containerClassNames: ['col-md-4 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormSelectComponent,
    name: OneClickPreviewField.Vehicle,
    label: 'views.one_click.vehicle',
    placeholder: 'views.one_click.select.vehicle',
    optionsLoader: OneClickVehiclesLoaderService,
    loading: OneClickPreviewVehiclesLoadingProvider,
    hidden: OneClickHasResultProvider,
    dynamicEffects: [OneClickSalesAreaErrorEffects],
    onChange: [OneClickSetVehicle, OneClickUpdateSalesArea],
    containerClassNames: ['col-md-6 text-capitalize retail-control mb-3'],
    validation: [Validators.required],
  } as FieldSelectConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Vehicle,
    text: OneClicVehicleProvider,
    hidden: OneClickNoResultProvider,
    label: 'views.one_click.vehicle',
    containerClassNames: ['col-md-4 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormInputNumberComponent,
    label: 'views.specifications.quantity',
    containerClassNames: ['col-md-3 retail-control'],
    name: OneClickPreviewField.Quantity,
    min: 1,
    value: 1,
    step: 1,
    max: 99999,
    decimals: DecimalProvider,
    validation: [Validators.required, Validators.min(1), Validators.max(99999)],
    onChange: [OneClickSetQuantityOrder],
    hidden: OneClickHasResultProvider,
  } as FieldInputNumberConfig,
  {
    type: FormSelectComponent,
    label: 'views.specifications.unit',
    name: OneClickBuilderField.Unit,
    placeholder: '',
    containerClassNames: ['col-md-3 retail-control'],
    onChange: [OneClickSetUnitOrder],
    dynamicEffects: [OneCLickAlternativeUnitsEffects],
    optionsLoader: OneClickUnitsLoaderService,
    validation: [Validators.required],
    hidden: OneClickHasResultProvider,
  } as FieldSelectConfig,
  {
    type: FormSelectComponent,
    label: 'views.specifications.plant',
    name: OneClickPreviewField.Plant,
    containerClassNames: ['col-md-6 text-capitalize retail-control mb-3'],
    placeholder: 'views.one_click.select_plant',
    optionsLoader: OneClickOwnFreightPlantsLoaderService,
    hidden: OneClickHasResultProvider,
    loading: OneClickPreviewOwnFreightPlantsLoadingProvider,
    onChange: [OneClickSetPlant],
    dynamicEffects: [OneClickOwnFreightPlantsEffects],
    validation: [Validators.required],
  } as FieldSelectConfig,
  {
    type: FormGenericItemComponent,
    name: '',
    text: OneClickStandardLotProvider,
    label: 'views.specifications.quantity',
    containerClassNames: ['col-md-4 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagquantity',
    dataTIdValue: 'cmx-createoneclickorder-lblvalquantity',
    hidden: OneClickNoResultProvider,
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Plant,
    text: OneClickOwnFreightPlantProvider,
    hidden: OneClickNoResultProvider,
    label: 'views.one_click.plant',
    containerClassNames: ['col-md-4 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormInputDateDisabledDatesComponent,
    label: 'views.specifications.request_ownfreight_date',
    name: OneClickPreviewField.OwnFreightDate,
    placeholder: '',
    translationNames: defaultDateTranslationNames,
    validation: [Validators.required],
    containerClassNames: ['col-md-6 text-capitalize retail-control'],
    dynamicEffects: [OneClickHolidaysEffects],
    forbiddenWeekDays: [WeekDay.SUNDAY],
    relativePosition: true,
    onChange: [OneClickSetRequestedDateTime],
    hidden: OneClickHasResultProvider,
    hideOutsideDays: true,
  } as FieldDateInputConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.OwnFreightDate,
    hidden: OneClickNoResultProvider,
    text: OneClickDeliveryDateProvider,
    label: 'views.specifications.request_ownfreight_date',
    containerClassNames: ['col-md-4 text-capitalize retail-control'],
  } as FieldLabelConfig,
  {
    type: MultipleContractTypeSelectorComponent,
    name: OneClickPreviewField.Contract,
    hidden: OneClickHasResultProvider,
    dynamicEffects: [OneClickContractEffects, ContractBalanceEffects],
    label: '',
    containerClassNames: ['col-md-12 mt-3'],
  } as FieldConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Contract,
    hidden: OneClickNoResultHasInvoiceProvider,
    text: OneClickContractProvider,
    label: 'views.one_click.contract',
    containerClassNames: ['col-md-6'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Contract,
    hidden: OneClickNoResultNoInvoiceProvider,
    text: OneClickContractProvider,
    label: 'views.one_click.invoice',
    containerClassNames: ['col-md-6'],
  } as FieldLabelConfig,
];
